import { Typography } from '@mui/material'
import { ReplacementForm } from '../../components/ReplacementForm'
import * as S from './ReplacementPage.styles'

export const ReplacementPage: React.FC = () => (
  <S.Wrapper>
    <S.TitleContainer>
      <Typography variant='h6' fontWeight='bold'>Reposição</Typography>
    </S.TitleContainer>
    <S.FormContainer>
      <ReplacementForm />
    </S.FormContainer>
  </S.Wrapper>
)
